import React from 'react';
import { Box, Button } from '@mui/material';
import { isEmpty } from 'lodash';
import { AddSubQuestionButtonProps } from './types';

const AddSubQuestionButton = ({ formValues, setFormValues, isEdit, subQuestion }: AddSubQuestionButtonProps) => {
  const addSubQuestion = () => {
    setFormValues({
      ...formValues,
      children_questions: [...formValues.children_questions, { name: '', description: '' }],
    });
  };

  if (!isEdit && !subQuestion.id && isEmpty(formValues.children_questions)) {
    return (
      <Box mt={4}>
        <Button variant="contained" color="primary" onClick={addSubQuestion}>
          Add Sub-question
        </Button>
      </Box>
    );
  }

  if (isEdit && !subQuestion.id && isEmpty(formValues.children_questions)) {
    return null;
  }

  return null;
};

export default AddSubQuestionButton;
